import Voters from "../Components/Voters"
function VotersPage(){
    return(
        <Voters/>
    )
   

}
export default VotersPage